"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserClient = void 0;
const base_client_1 = require("@deliverr/base-client");
const commons_logs_1 = require("@deliverr/commons-logs");
const SellerServiceUtil_1 = require("./SellerServiceUtil");
const defaultConfig = {
    baseUrl: process.env.SELLER_SERVICE_URL,
    user: process.env.SELLER_BASIC_AUTH_USER,
    password: process.env.SELLER_BASIC_AUTH_PASSWORD,
};
class UserClient extends base_client_1.ApiBasicAuthClient {
    constructor(config = defaultConfig) {
        super({
            baseURL: `${config.baseUrl}/v1`,
            basicAuthPassword: config.password,
            basicAuthUser: config.user,
        });
        if (!config.user || !config.password) {
            commons_logs_1.log.warn("SELLER_BASIC_AUTH_USER and SELLER_BASIC_AUTH_PASSWORD environment variable is not set");
        }
    }
    async getUserFromOrganization(email) {
        try {
            return await this.get("/user", { email });
        }
        catch (error) {
            (0, SellerServiceUtil_1.handleSellerServiceError)("getUserFromOrganization", error);
        }
    }
    async getUserSignupData(email) {
        try {
            return await this.get("/user/signupData", { email });
        }
        catch (error) {
            (0, SellerServiceUtil_1.handleSellerServiceError)("getUserSignupData", error);
        }
    }
    async completeInvitedUserSignup(email, cognitoId) {
        try {
            return await this.put(`/user/${email}/completeUserSignup`, { cognitoId });
        }
        catch (error) {
            (0, SellerServiceUtil_1.handleSellerServiceError)("completeInvitedUserSignup", error);
        }
    }
    async setMfa(mfaMethods, preferredMfa) {
        try {
            return await this.put(`/user/mfa`, {
                mfaMethods,
                preferredMfa,
            });
        }
        catch (error) {
            (0, SellerServiceUtil_1.handleSellerServiceError)("setMfa", error);
        }
    }
    async getMfa() {
        try {
            return await this.get(`/user/mfa`);
        }
        catch (error) {
            (0, SellerServiceUtil_1.handleSellerServiceError)("getMfa", error);
        }
    }
    async getSurveyResponse(surveyName, surveyVersion) {
        try {
            return await this.get(`/survey/${surveyName}/${surveyVersion}/response`);
        }
        catch (error) {
            (0, SellerServiceUtil_1.handleSellerServiceError)("getSurveResponse", error);
        }
    }
    async setSurveyResponse(surveyName, surveyVersion, questions) {
        try {
            return await this.put(`/survey/${surveyName}/${surveyVersion}/response`, {
                questions,
            });
        }
        catch (error) {
            (0, SellerServiceUtil_1.handleSellerServiceError)("setSurveyResponse", error);
        }
    }
    async userExists(email) {
        try {
            return await this.get("/user/exists", { email });
        }
        catch (error) {
            (0, SellerServiceUtil_1.handleSellerServiceError)("userExists", error);
        }
    }
    async deletePendingUser(email) {
        try {
            return await this.delete("/user/delete", { email });
        }
        catch (error) {
            (0, SellerServiceUtil_1.handleSellerServiceError)("deletePendingUser", error);
        }
    }
    async deactivateUser(email) {
        try {
            return await this.delete("/user/deactivate", { email });
        }
        catch (error) {
            (0, SellerServiceUtil_1.handleSellerServiceError)("deactivateUser", error);
        }
    }
    async activateUser(email) {
        try {
            return await this.put("/user/activate", {}, { email });
        }
        catch (error) {
            (0, SellerServiceUtil_1.handleSellerServiceError)("activateUser", error);
        }
    }
    async updateContactArea(contactArea, updates) {
        try {
            return await this.patch(`user/contactArea/${contactArea}`, updates);
        }
        catch (error) {
            (0, SellerServiceUtil_1.handleSellerServiceError)("updateContactArea", error);
        }
    }
    async getUsersFromPartialMatch(partialString) {
        try {
            return await this.get("/user/partial_match", {
                q: partialString,
            });
        }
        catch (error) {
            (0, SellerServiceUtil_1.handleSellerServiceError)("getUsersFromPartialMatch", error);
        }
    }
    async userChangeOrganization(email, newOrganizationId) {
        try {
            return await this.put(`/user/${email}/change-organization`, {
                newOrganizationId,
            });
        }
        catch (error) {
            (0, SellerServiceUtil_1.handleSellerServiceError)("userChangeOrganization", error);
        }
    }
    async updateUser(email, update) {
        try {
            return await this.put(`/user/update/${email}`, update);
        }
        catch (error) {
            (0, SellerServiceUtil_1.handleSellerServiceError)("updateUser", error);
        }
    }
}
exports.UserClient = UserClient;
//# sourceMappingURL=UserClient.js.map